/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'template': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M921.6 102.4v358.4h-256V102.4h256m-563.2 0V256h-256V102.4h256m0 460.8v358.4h-256V563.2h256M921.6 768v153.6h-256V768h256m0-768h-256c-56.32 0-102.4 46.08-102.4 102.4v358.4c0 56.32 46.08 102.4 102.4 102.4h256c56.32 0 102.4-46.08 102.4-102.4V102.4C1024 46.08 977.92 0 921.6 0zM358.4 0h-256C46.08 0 0 46.08 0 102.4V256c0 56.32 46.08 102.4 102.4 102.4h256c56.32 0 102.4-46.08 102.4-102.4V102.4C460.8 46.08 414.72 0 358.4 0zm0 460.8h-256C46.08 460.8 0 506.88 0 563.2v358.4C0 977.92 46.08 1024 102.4 1024h256c56.32 0 102.4-46.08 102.4-102.4V563.2c0-56.32-46.08-102.4-102.4-102.4zm563.2 204.8h-256c-56.32 0-102.4 46.08-102.4 102.4v153.6c0 56.32 46.08 102.4 102.4 102.4h256c56.32 0 102.4-46.08 102.4-102.4V768c0-56.32-46.08-102.4-102.4-102.4z"/>'
  }
})
